import { gql } from 'shared/types/layoutcreator'

export const GET_FEATURE_FLAGS = gql(/* GraphQL */ `
  query featureFlags {
    featureFlags {
      key
      name
      description
      state
      limitedGroupIds
    }
  }
`)

export const IS_FEATURE_AVAILABLE = gql(/* GraphQL */ `
  query isFeatureAvailable($key: String!) {
    isFeatureAvailable(key: $key)
  }
`)

